import tw from "tailwind.macro"

const Marker = tw.span`
  text-green-400
`

export default Marker
